{
  "title": "Activate a server with a code",
  "description": "Enter the code your server shows during the install to link it to your account.",
  "noAccess": {
    "title": "The owner, admins and technical members can activate servers",
    "body": "Ask one of them to activate the server, or ask for a different team role."
  },
  "enter": {
    "label": "Activation code",
    "hint": "8 letters and numbers, like K7QD-2MXR.",
    "where": "The server shows the code after you run {{command}}.",
    "noCode": "No code? Add a server with an activation key"
  },
  "error": {
    "another": "Use another code"
  },
  "found": {
    "title": "The server asking to activate",
    "body": "This is what the installer sent with code {{code}}.",
    "expires_one": "The code expires in {{count}} minute.",
    "expires_other": "The code expires in {{count}} minutes.",
    "check": "Make sure this is your server before you approve. We never ask for this code by email or phone.",
    "footnote": "The installer asked for the code at {{time}}."
  },
  "choose": {
    "title": "Link the server",
    "attach": "A server waiting for activation",
    "attachBody_one": "You have {{count}} server you added that isn't activated yet.",
    "attachBody_other": "You have {{count}} servers you added that aren't activated yet.",
    "attachNone": "You have no servers waiting for activation.",
    "new": "A new server",
    "newTrial": "Starts on your free trial.",
    "newPaid": "A new subscription; you pay the first period before the install.",
    "renames": "We'll change the hostname from {{from}} to {{to}}, as the server reported.",
    "paidNote": "After you approve, you pay the first period, then the installer finishes activating.",
    "approve": "Approve and activate"
  },
  "approved": {
    "title": "Approved",
    "body": "We sent the subscription to {{host}}. The installer finishes the activation in a few seconds.",
    "another": "Activate another server",
    "open": "View server"
  },
  "demo": {
    "title": "Demo data: codes to try",
    "body": "The demo has no real installer. Create a code as if a server asked for one, or try the error states.",
    "fresh": "Simulate an installer showing a code",
    "expired": "Expired code",
    "used": "Used code",
    "unknown": "Unknown code"
  }
}
